import { formatTStoDATE, parseDateTimeToTS, parseDateToTS } from './index';
import type { IUniversalDate } from './base-datetime';
import { convertDatesToTS } from './base-datetime';
import dayjs from 'dayjs';

export type IQuarter = {
    label: string;
    value: number;
    name: string;
    date_start: number;
    date_end: number;
    field: string;
};
// Возвращает список кварталов по году - year
// [{
// label, name, value, date_start, date_end
// }]
export function getListQuarter(year: string | number, field?: string | null): IQuarter[] {
    let yearString: string | null = null; // храним год ввиде строки
    let yearNumber: number | null = null; // храним год ввиде числа

    if (typeof year === 'string' || (year && year.toString()?.length === 4)) {
        yearNumber = parseDateTimeToTS(`01/01/${year.toString()} 00:00`);
        yearString = year.toString();
    }

    if (typeof year === 'number' && year && year.toString()?.length > 4) {
        yearString = formatTStoDATE(year, 'YYYY');
    }
    if (!yearNumber || !yearString) {
        throw new TypeError(`getListQuarter(${year}, ${field}) - invalid types`);
    }

    const withYear = dayjs().year(+year);
    const startOfMonth_3 = withYear.month(2).startOf('month');
    const startOfMonth_6 = withYear.month(5).startOf('month');
    const startOfMonth_9 = withYear.month(8).startOf('month');
    const startOfMonth_12 = withYear.month(11).startOf('month');

    return [
        {
            label: `1 кв. ${year ?? ''}`,
            value: 1,
            name: `1 кв. ${year ?? ''}`,
            date_start: yearNumber,
            date_end: startOfMonth_3.endOf('month').valueOf(),
            field: `${field ? field + '_' : ''}quarter_${yearString}_1`,
        },
        {
            label: `2 кв. ${year ?? ''}`,
            value: 2,
            name: `2 кв. ${year ?? ''}`,
            date_start: parseDateTimeToTS(`01/04/${yearString} 00:00`),
            date_end: startOfMonth_6.endOf('month').valueOf(),
            field: `${field ? field + '_' : ''}quarter_${yearString}_2`,
        },
        {
            label: `3 кв. ${year ?? ''}`,
            value: 3,
            name: `3 кв. ${year ?? ''}`,
            date_start: parseDateTimeToTS(`01/07/${yearString} 00:00`),
            date_end: startOfMonth_9.endOf('month').valueOf(),
            field: `${field ? field + '_' : ''}quarter_${yearString}_3`,
        },
        {
            label: `4 кв. ${year ?? ''}`,
            value: 4,
            name: `4 кв. ${year ?? ''}`,
            date_start: parseDateTimeToTS(`01/10/${yearString} 00:00`),
            date_end: startOfMonth_12.endOf('month').valueOf(),
            field: `${field ? field + '_' : ''}quarter_${yearString}_4`,
        },
    ];
}

// вытаскиваем определенный квартал по году и по value_квартала
export function getItemQuarter(quarter: number, year: string | number, field?: string | null) {
    return getListQuarter(year, field).find((p) => p.value === quarter);
}

// Получение кварталов по периоду ввиде объекта
export function getQuarterByPeriod(
    dateStart: IUniversalDate | null,
    dateEnd: IUniversalDate | null,
    sort: 'asc' | 'desc' = 'asc',
    field: string
) {
    let [date_start, date_end] = convertDatesToTS(dateStart, dateEnd);
    if (!date_start || !date_end) return;

    if (date_end < date_start) {
        const temp_date_start = date_start;
        date_start = date_end;
        date_end = temp_date_start;
    }

    const list: IQuarter[] = [];

    do {
        const quarter = getQuarterByDate(date_start, field);
        if (!quarter) break;

        if (!list?.length || list.every((l) => l?.field !== quarter.field)) {
            list.push({
                ...quarter,
            });
        }

        date_start += 27 * 24 * 60 * 60 * 1000;
    } while (date_start <= date_end);

    if (sort === 'desc') list.sort((a, b) => b.date_start - a.date_start);
    if (sort === 'asc') list.sort((a, b) => a.date_start - b.date_start);

    return list;
}

// Получение кварталов по дате ввиде объекта
// {label, value, name, date_start, date_end }
// name - номер_квартала кв год
export function getQuarterByDate(date: string | Date | number | null, field: string) {
    if (!date) return;
    let ts: number | Date | null;
    if (typeof date === 'string') ts = parseDateToTS(date);
    else ts = date;
    if (!ts) return;

    const date_temp = new Date(date);
    if (!date_temp) return;

    // номер квартала и год
    return getItemQuarter(Math.floor((date_temp.getMonth() + 3) / 3), date_temp.getFullYear(), field);
}
